import { useState, useContext } from "react";
import { AuthContext } from "../../../contexts/AuthContext";

const ROLES = {
  ADMIN: "ADMIN",
  DATA_MANAGER: "DATA_MANAGER",
  LOGISTICS_COORDINATOR: "LOGISTICS_COORDINATOR",
  AREA_COORDINATOR: "AREA_COORDINATOR",
  CLIENT: "CLIENT",
};

const PERMISSIONS = {
  CREATE_DUKA_STOCK: "DUKA_STOCK_add",
  EDIT_DUKA_STOCK: "DUKA_STOCK_change",
  DELETE_DUKA_STOCK: "DUKA_STOCK_delete",
  VIEW_DUKA_STOCK: "DUKA_STOCK_view",
};

const ROLE_PERMISSIONS = {
  [ROLES.ADMIN]: [
    PERMISSIONS.CREATE_DUKA_STOCK,
    PERMISSIONS.EDIT_DUKA_STOCK,
    PERMISSIONS.DELETE_DUKA_STOCK,
    PERMISSIONS.VIEW_DUKA_STOCK,
  ],
  [ROLES.DATA_MANAGER]: [PERMISSIONS.VIEW_DUKA_STOCK],
  [ROLES.LOGISTICS_COORDINATOR]: [
    PERMISSIONS.EDIT_DUKA_STOCK,
    PERMISSIONS.VIEW_DUKA_STOCK,
  ],
  [ROLES.AREA_COORDINATOR]: [
    PERMISSIONS.EDIT_DUKA_STOCK,
    PERMISSIONS.VIEW_DUKA_STOCK,
  ],
  [ROLES.CLIENT]: [PERMISSIONS.VIEW_DUKA_STOCK],
};

const useDukaStockPermissions = () => {
  const { user } = useContext(AuthContext);
  const [loading] = useState(false);
  const [error] = useState(null);

  const hasPermission = (permission) => {
    if (!user?.role?.name) return false;
    return ROLE_PERMISSIONS[user.role.name]?.includes(permission) || false;
  };

  const can = {
    createDukaStock: () => hasPermission(PERMISSIONS.CREATE_DUKA_STOCK),
    editDukaStock: () => hasPermission(PERMISSIONS.EDIT_DUKA_STOCK),
    deleteDukaStock: () => hasPermission(PERMISSIONS.DELETE_DUKA_STOCK),
    viewDukaStock: () => hasPermission(PERMISSIONS.VIEW_DUKA_STOCK),
  };

  return {
    loading,
    error,
    can,
    ROLES,
    PERMISSIONS,
  };
};

export default useDukaStockPermissions;
